@if (line) {
  <app-blade-header [bladeIndex]="bladeIndex" (closeClicked)="closeBlade()">
    <ng-container title>
      <i class="icon fas fa-route"></i>
      @if (title$ | async; as title) {
        {{title}}
      }
    </ng-container>
  </app-blade-header>
  <app-tabs [tabs]="componentState?.tabs" [tabsInfo]="tabsInfo" [selectedTab]="componentState?.selectedTab" (changed)="changeTab($event)"></app-tabs>
  @if (componentState?.selectedTab === 'vehicles') {
    <div class="d-flex flex-spacer w-100">
      @if (vehicleItems) {
        @if (vehicleItems.length > 0) {
          <app-compact-list [items]="vehicleItems" [columns]="componentState?.vehicleColumns" (itemSelected)="vehicleItemSelected($event)" (columnsUpdated)="vehicleColumnsUpdated($event)"></app-compact-list>
        } @else {
          <span class="text-tiny p-4" translate>This line has no active vehicles right now</span>
        }
      } @else {
        <div class="p-4 flex-spacer">
          <places-spinner small="true"></places-spinner>
        </div>
      }
    </div>
  }
  @if (componentState?.selectedTab === 'line-view' && lineViewAccessEnabled) {
    @if (lineViewService.loadingVariants()) {
      <div class="p-4 flex-spacer">
        <places-spinner small="true"></places-spinner>
      </div>
    } @else if (lineViewService.activeStops().length > 0) {
      <app-line-view></app-line-view>
    } @else {
      <span class="text-tiny p-4" translate>No stop data available for this line</span>
    }
  }
  @if (drawingLineInMap) {
    <div class="loading">
      <places-spinner small="true"></places-spinner>
      <span translate>Drawing line in map</span>
    </div>
  }
  @if (noGeometries && componentState?.selectedTab !== 'line-view') {
    <div class="loading">
      <span translate>No GPS data found for the route</span>
    </div>
  }
}
